import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Estimated Cursor Cost',
      type: 'metric',
      content: {
        '{}': {
          name: 'Estimated Cursor Cost',
          value: {
            '{}': {
              quality: 'neutral',
              tooltip:
                'Estimated Cursor cost for the selected project or all projects.',
              emphasis: {
                'fmt.num': [
                  {
                    '+': {
                      '@': 'estimatedCostValues',
                    },
                  },
                  '$',
                ],
              },
            },
          },
          description: 'Total estimated cost of recorded Cursor usage.',
        },
      },
    },
  },
  subqueries: {
    estimatedCostValues: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'projectId',
              },
              null,
            ],
          },
          {
            in: [
              {
                '@.': [
                  '!project',
                  {
                    ref: {
                      entity: '!proj',
                    },
                  },
                ],
              },
              {
                '@>': [
                  {
                    '@$': 'projectId',
                  },
                  'ent:!projects:!proj',
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!cursor_usage_events:!cursor_usage_event',
      selection: {
        '@.': '!est_cost_usd',
      },
    },
  },
}
